import { Initializer } from '@adobe-commerce/elsie/lib';
import { Lang } from '@adobe-commerce/elsie/i18n';
import { events } from '@adobe-commerce/event-bus';
import { state, DEFAULT_PERMISSIONS } from '@/quote-management/lib/state';
import { getCustomerData } from '@/quote-management/api/getCustomerData';

type ConfigProps = {
  langDefinitions?: Lang;
};

export const initialize = new Initializer<ConfigProps>({
  init: async (config) => {
    const defaultConfig = {};

    initialize.config.setConfig({ ...defaultConfig, ...config });
  },

  listeners: () => [
    events.on('authenticated', async (authenticated) => {
      state.authenticated = !!authenticated;

      if (authenticated) {
        getCustomerData().then((customerData) => {
          state.permissions = {
            requestQuote: customerData.permissions.canRequestQuote,
            editQuote: customerData.permissions.canEditQuote,
            deleteQuote: customerData.permissions.canDeleteQuote,
          };
          events.emit('quote-management/permissions', state.permissions);
        })
          .catch((error) => {
            console.error(error);
            state.permissions = DEFAULT_PERMISSIONS;
            events.emit('quote-management/permissions', DEFAULT_PERMISSIONS);
          });
      } else {
        state.permissions = DEFAULT_PERMISSIONS;
        events.emit('quote-management/permissions', DEFAULT_PERMISSIONS);
      }
    }, {
      eager: true,
    }),
  ],
});

export const config = initialize.config;
